import Vue from "vue";
import VueRouter from "vue-router";

// Load patient and provider routes
import PatientRoutes from "./patient.js";
import ProviderRoutes from "./provider.js";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "LoginComponent",
        component: () =>
            import(
                /* webpackChunkName: "LoginPage" */
                "@/modules/account/login/LoginView.vue"
            ),
    },
    {
        path: "/login",
        name: "LoginList",
        component: () =>
            import(
                /* webpackChunkName: "LoginList" */
                "@/modules/account/login/AccountListView.vue"
            ),
    },

    // We don't have passwords, so I'm not sure what this is used for anymore.
    // {
    //   path: "/forgot",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "ForgotPassword" */
    //       "@/modules/account/login/ForgotPasswordView.vue"
    //     ),
    // },
    {
        path: "/register",
        component: () =>
            import(
                /* webpackChunkName: "RegisterBase.vue" */
                "@/modules/account/register/RegisterBase.vue"
            ),
        children: [
            {
                path: "provider",
                component: () =>
                    import(
                        /* webpackChunkName: "RegisterVerify" */
                        "@/modules/account/register/RegisterVerifyView.vue"
                    ),
            },
            {
                path: "provider/new",
                component: () =>
                    import(
                        /* webpackChunkName: "ProviderRegister" */
                        "@/modules/account/register/ProviderRegisterView.vue"
                    ),
            },
            {
                path: "patient",
                component: () =>
                    import(
                        /* webpackChunkName: "RegisterVerify" */
                        "@/modules/account/register/RegisterVerifyView.vue"
                    ),
            },
            {
                path: "patient/new",
                component: () =>
                    import(
                        /* webpackChunkName: "PatientRegister" */
                        "@/modules/account/register/PatientRegisterView.vue"
                    ),
            },
        ],
    },
    {
        path: "/email/change",
        name: "ChangeEmail",
        component: () =>
            import(
                /* webpackChunkName: "EmailChange"*/
                "@/modules/patient/views/change/ChangeEmailView.vue"
            ),
    },
    {
        path: "/email/verify",
        name: "VerifyEmail",
        component: () =>
            import(
                /* webpackChunkName: "EmailVerify"*/
                "@/modules/patient/views/change/VerifyEmailView.vue"
            ),
    },
    {
        path: "/phone/change",
        name: "ChangePhone",
        component: () =>
            import(
                /* webpackChunkName: "PhoneChange"*/
                "@/modules/patient/views/change/ChangePhoneView.vue"
            ),
    },
    {
        path: "/phone/verify",
        name: "VerifyPhone",
        component: () =>
            import(
                /* webpackChunkName: "PhoneVerify"*/
                "@/modules/patient/views/change/VerifyPhoneView.vue"
            ),
    },

    {
        path: "/assessment",
        component: () =>
            import(
                /* webpackChunkName: "AssessmentPage" */
                "@/modules/assessments/views/AssessmentView.vue"
            ),
    },

    PatientRoutes,
    ProviderRoutes,
    {
        path: "/404",
        component: () =>
            import(
                /* webpackChunkName: "NotFound" */
                "@/views/NotFound.vue"
            ),
    },
    {
        path: "/:catchAll(.*)",
        redirect: "/404",
    },
   
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return {
            selector: "#content",
            behavior: "smooth",
        };
    },
});

router.beforeEach((to, from, next) => {
    next();
});

export default router;
